import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useMemo } from 'react';
import { PlainDate } from 'temporal-luxon';
import { DatePicker, useLocalizeMessage } from 'libs.nucleus';
import { EM_DASH } from 'libs.react';
const DateRangeSelector = ({ value, onChange, disabled = false, minDate, maxDate }) => {
    const translate = useLocalizeMessage();
    const handleFromChange = useCallback((date) => {
        if (date === value.from) {
            return;
        }
        let newToDate = value.to;
        if (date && value.to && PlainDate.compare(date, value.to) > 0) {
            newToDate = undefined;
        }
        onChange({ from: date, to: newToDate });
    }, [value.from, value.to, onChange]);
    const handleToChange = useCallback((date) => {
        if (date === value.to) {
            return;
        }
        let newFromDate = value.from;
        if (date && value.from && PlainDate.compare(value.from, date) > 0) {
            newFromDate = undefined;
        }
        onChange({ from: newFromDate, to: date });
    }, [value.from, value.to, onChange]);
    const fromDateConstraints = useMemo(() => ({
        startDate: minDate,
        endDate: value.to || maxDate,
    }), [minDate, maxDate, value.to]);
    const toDateConstraints = useMemo(() => ({
        startDate: value.from || minDate,
        endDate: maxDate,
    }), [minDate, maxDate, value.from]);
    return (_jsxs("div", { className: 'flex flex-row items-end gap-2', role: 'group', "aria-label": 'Date range selector', children: [_jsx(DatePicker, { id: 'from-date-picker', width: 'sm', value: value.from, onChange: handleFromChange, disabled: disabled, startDate: fromDateConstraints.startDate, endDate: fromDateConstraints.endDate, label: translate('label.date_range_selector.from') }), _jsx("span", { className: 'text-sm mb-2', "aria-hidden": 'true', children: EM_DASH }), _jsx(DatePicker, { id: 'to-date-picker', width: 'sm', value: value.to, onChange: handleToChange, disabled: disabled, startDate: toDateConstraints.startDate, endDate: toDateConstraints.endDate, label: translate('label.date_range_selector.to') })] }));
};
export default DateRangeSelector;
